module.exports = __webpack_public_path__ + "bd77095829b8e45506385d11235c3e2d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/toolbar/text.svg
// module id = 31
// module chunks = 0